import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=63fa03bf&scoped=true&"
import script from "./registry.vue?vue&type=script&lang=js&"
export * from "./registry.vue?vue&type=script&lang=js&"
import style0 from "./registry.vue?vue&type=style&index=0&id=63fa03bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa03bf",
  null
  
)

export default component.exports